// alterado

import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import {
    GridContainerReport,
    GridItem2,
    GridItem3,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridDivider,
    CardGridDivBody,
} from '../../../business-components/Card/Card'

import {
    formataPrimeiraReuniaoLabel,
    formataPrimeiraReuniaoTexto,
    formataPrimeiraReuniaoTextoDestaque,
    formataCpf,
    formataPrimeiraReuniaoValor,
    formataPrimeiraReuniaoNumero,
} from '../../../business-components/Formata/Formata'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import formList from '../../../business-rules/List/formList'

import tipoPoliticaInvestimentoList from '../../../business-rules/List/tipoPoliticaInvestimentoList'

import {
    descricaoResumidaPergunta,
    valorPergunta,
    simNaoPergunta,
} from '../form-form/FormServicePerguntas'



const EstudoReportPrimeiraReuniaoInputsInvestimento = ({ values }) => {

    const linhaFormList = pesquisaList(formList, values.idFormList)

    return (
        <>
            <GridItem12>
                <GridContainerReport>
                    <GridItem12 align="center">
                        {
                            formataPrimeiraReuniaoTextoDestaque(values.nomeCliente)
                        }
                    </GridItem12>
                </GridContainerReport>

                <br/>

                <CardGridDivider/>

                <CardGridDivBody>
                    <GridContainerReport>
                        <GridItem3>
                            {
                                formataPrimeiraReuniaoLabel(LABEL.idade)
                            }
                        </GridItem3>
                        <GridItem2>
                            {
                                formataPrimeiraReuniaoNumero(values.idadeCliente)
                            }
                        </GridItem2>
                        <GridItem2 />

                        {linhaFormList.idQuantoPossuiParaInvestir
                            ?
                                <>
                                    <GridItem3>
                                        {
                                            formataPrimeiraReuniaoLabel(descricaoResumidaPergunta(linhaFormList,
                                                linhaFormList.idQuantoPossuiParaInvestir))
                                        }
                                    </GridItem3>
                                    <GridItem2>
                                        {
                                            formataPrimeiraReuniaoValor(valorPergunta(values,
                                                linhaFormList.idQuantoPossuiParaInvestir))
                                        }
                                    </GridItem2>
                                </>
                            :
                                ''
                        }
                    </GridContainerReport>

                    <GridContainerReport>
                        <GridItem3>
                            {
                                formataPrimeiraReuniaoLabel(LABEL.cpf)
                            }
                        </GridItem3>
                        <GridItem2>
                            {
                                formataPrimeiraReuniaoTexto(formataCpf(values.cpfCliente))
                            }
                        </GridItem2>
                        <GridItem2 />
                        
                        {linhaFormList.idPatrimonioImobilizado
                            ?
                                <>
                                    <GridItem3>
                                        {
                                            formataPrimeiraReuniaoLabel(descricaoResumidaPergunta(linhaFormList,
                                                linhaFormList.idPatrimonioImobilizado))
                                        }
                                    </GridItem3>
                                    <GridItem2>
                                        {
                                            formataPrimeiraReuniaoValor(valorPergunta(values,
                                                linhaFormList.idPatrimonioImobilizado))
                                        }
                                    </GridItem2>
                                </>
                            :
                                ''
                        }
                    </GridContainerReport>
                    
                    {values.tipoPoliticaInvestimentoCliente || linhaFormList.idRecursosFinanceiros
                        ?
                            <>
                                <GridContainerReport>
                                    {values.tipoPoliticaInvestimentoCliente
                                        ?
                                            <>
                                                <GridItem3>
                                                    {
                                                        formataPrimeiraReuniaoLabel(LABEL.tipoPoliticaInvestimento)
                                                    }
                                                </GridItem3>
                                                <GridItem2>
                                                    {
                                                        formataPrimeiraReuniaoTexto(pesquisaList(tipoPoliticaInvestimentoList,
                                                            values.tipoPoliticaInvestimentoCliente).descricao)
                                                    }
                                                </GridItem2>
                                            </>
                                        :
                                            <>
                                                <GridItem3 />
                                                <GridItem2 />
                                            </>
                                    }

                                    <GridItem2 />
                                    
                                    {linhaFormList.idRecursosFinanceiros
                                        ?
                                            <>
                                                <GridItem3>
                                                    {
                                                        formataPrimeiraReuniaoLabel(descricaoResumidaPergunta(linhaFormList,
                                                            linhaFormList.idRecursosFinanceiros))
                                                    }
                                                </GridItem3>
                                                <GridItem2>
                                                    {
                                                        formataPrimeiraReuniaoValor(valorPergunta(values,
                                                            linhaFormList.idRecursosFinanceiros))
                                                    }
                                                </GridItem2>
                                            </>
                                        :
                                            ''
                                    }
                                </GridContainerReport>
                            </>
                        :
                            ''
                    }

                    {linhaFormList.idNecessidadeUtilizacao5anos
                        ?
                            <>
                                <GridContainerReport>
                                    <GridItem3 />
                                    <GridItem2 />
                                    <GridItem2 />

                                    <GridItem3>
                                        {
                                            formataPrimeiraReuniaoLabel(descricaoResumidaPergunta(linhaFormList,
                                                linhaFormList.idNecessidadeUtilizacao5anos))
                                        }
                                    </GridItem3>
                                    <GridItem2>
                                        {
                                            formataPrimeiraReuniaoTexto(simNaoPergunta(values,
                                                linhaFormList.idNecessidadeUtilizacao5anos))
                                        }
                                    </GridItem2>
                                </GridContainerReport>
                            </>
                        :
                            ''
                    }
                </CardGridDivBody>
            </GridItem12>

            {values.tipoPoliticaInvestimentoCliente
                ?
                    <GridItem12>
                        <br/>
                        <br/>
                        <br/>

                        <div
                            className="m-0 text-muted text-12"
                            dangerouslySetInnerHTML={{ __html: 
                                pesquisaList(tipoPoliticaInvestimentoList,
                                    values.tipoPoliticaInvestimentoCliente).descricaoDetalhada
                            }}
                        />
                    </GridItem12>
                :
                    ''
            }
        </>
    )
}

export default EstudoReportPrimeiraReuniaoInputsInvestimento